import {
  SET_EMERGENCY_CONTACT_FORM_FIELD,
  SET_EMERGENCY_CONTACT_FORM
} from 'actions/account/emergencyContacts/actionTypes'

const form = (state = {}, action) => {
  switch (action.type) {
    case SET_EMERGENCY_CONTACT_FORM_FIELD:
      return Object.assign({}, state, { [action.field]: action.value })
    case SET_EMERGENCY_CONTACT_FORM:
      return action.data
    default:
      return state
  }
}

export default form
